import { setLicenseKey } from "survey-core"
import { IDocOptions, SurveyPDF } from "survey-pdf"

const DEFAULT_PDF_OPTIONS: IDocOptions = {
  fontSize: 12,
  format: "a4"
}

export type IntakeFormPdfOptions = {
  surveyJson: Record<string, unknown> | string
  data?: Record<string, unknown> | null
  fileName?: string
  licenseKey?: string | null
}

function parseSurveyJson(surveyJson: Record<string, unknown> | string): Record<string, unknown> {
  return typeof surveyJson === "string" ? JSON.parse(surveyJson) : surveyJson
}

function sanitizeFileName(name: string): string {
  const base = name.trim().replace(/[^\w\s-]/g, "").replace(/\s+/g, "-").replace(/-+/g, "-")
  return base.length > 0 ? base : "intake-form"
}

function applyLicense(licenseKey?: string | null): void {
  if (licenseKey) {
    setLicenseKey(licenseKey)
  }
}

async function buildSurveyPdf({ surveyJson, data, licenseKey }: IntakeFormPdfOptions): Promise<SurveyPDF> {
  applyLicense(licenseKey)

  const surveyPdf = new SurveyPDF(parseSurveyJson(surveyJson), DEFAULT_PDF_OPTIONS)
  if (data && Object.keys(data).length > 0) {
    surveyPdf.data = data
  }

  return surveyPdf
}

export async function downloadIntakeFormPdf(options: IntakeFormPdfOptions): Promise<void> {
  const surveyPdf = await buildSurveyPdf(options)
  const fileName = `${sanitizeFileName(options.fileName || "intake-form")}.pdf`
  await surveyPdf.save(fileName)
}


export async function printIntakeFormPdf(options: IntakeFormPdfOptions): Promise<void> {
  const surveyPdf = await buildSurveyPdf(options)
  const blobUrl = await surveyPdf.raw("bloburl")

  const printWindow = window.open(blobUrl, "_blank")
  if (!printWindow) {
    URL.revokeObjectURL(blobUrl)
    throw new Error("Pop-up blocked. Allow pop-ups to print this form.")
  }

  printWindow.addEventListener("load", () => {
    printWindow.focus()
    printWindow.print()
    // Revoke after a delay to ensure print dialog has accessed the blob
    setTimeout(() => URL.revokeObjectURL(blobUrl), 1000)
  })
}

